import { create } from 'zustand'
import type { Merchant } from '../types'

interface MerchantState {
  merchant: Merchant | null
  loading: boolean
  setMerchant: (merchant: Merchant) => void
  setLoading: (loading: boolean) => void
  updateMerchant: (updates: Partial<Merchant>) => void
  clearMerchant: () => void
}

export const useMerchantStore = create<MerchantState>((set) => ({
  merchant: null,
  loading: false,

  setMerchant: (merchant: Merchant) => {
    set({ merchant, loading: false })
  },

  setLoading: (loading: boolean) => {
    set({ loading })
  },

  updateMerchant: (updates: Partial<Merchant>) => {
    set((state) => ({
      merchant: state.merchant ? { ...state.merchant, ...updates } : null,
    }))
  },

  clearMerchant: () => {
    set({ merchant: null, loading: false })
  },
}))
